import styled from 'styled-components';
import { typography, space, flexbox, compose, position, layout, system } from 'styled-system';
import { getTextColor, color, gap } from '@magalu/stereo-ui-styles';
export const Container = styled.p.attrs(props => ({
  color: props.color ? getTextColor(props.color)(props) || props.color : getTextColor('base')(props)
}))`
  ${compose(typography, space, color, layout, position, flexbox, gap)}
  ${system({
  transform: true
})}
`;